import { useState } from 'react';
import { Box, TableRow, Typography } from '@mui/material';

import { useAppContext } from '../../../../../context/appContext/appContext';
import TableCellView from '../../../../../components/pageContent/TableView/TableCellView';

import React from 'react';

import { DriverWorkedHours, ReportToDriverDB } from '../../../types';
import LoupeIcon from '../../../../../components/uiComponents/LoupeIcon';
import DataCollapse from './DataCollapse';
import { WORKING_HOURS } from '../../../../../constants';

type Props = {
	report: ReportToDriverDB;
	onEdit: (id: number) => void;
	onDeleteConfirm: (id: number, name: string) => void;
};

const DataTableRows = ({ report, onEdit, onDeleteConfirm }: Props) => {
	const [open, setOpen] = useState(false);
	const [openId, setOpenId] = useState(0);

	const { state } = useAppContext();

	const handleOpen = async (id: number) => {
		setOpen(false);
		setOpenId(0);

		if (openId !== id) {
			setOpen(true);
			setOpenId(id);
		}
	};

	const col1 = 120;
	const basicWorkingHours = WORKING_HOURS;

	const costs = report.costs * 1;

	// spocitame hodiny
	const workedHours = report.workedHours * 1;
	const sale = report.user.contractToUsers[0].buyDriver * 1;
	const saleOverDB = report.user.contractToUsers[0].buyOverDriver * 1;

	// spocitam prehled
	let normalHours = 0;
	let overLimitHours = 0;
	let saleOver = sale * 1 + saleOverDB * 1;
	let priceNormalHours = 0;
	let priceOverHours = 0;
	let totalPriceHoursDay = 0;

	if (workedHours > basicWorkingHours) {
		overLimitHours = workedHours - basicWorkingHours;

		priceOverHours = overLimitHours * saleOver;
	}

	normalHours = workedHours * 1 - overLimitHours * 1;
	priceNormalHours = normalHours * sale;
	totalPriceHoursDay = priceOverHours + priceNormalHours + costs;

	return (
		<>
			{/* Celkem hodiny */}
			<TableRow>
				<TableCellView align="left" mW={col1}>
					<Typography sx={{ fontWeight: 'bold' }} variant="body2">
						Počet hodin
					</Typography>
				</TableCellView>

				<TableCellView align="left" mW={200}>
					<>
						<Box
							sx={{
								display: 'flex',
								justifyContent: 'flex-start',
								flexDirection: 'row',
								alignItems: 'center',
							}}>
							<Typography sx={{ fontWeight: 'bold', marginRight: 1 }} component="span" variant="body2">
								{`${report.workedHours * 1} hod.`}
							</Typography>
							<LoupeIcon
								onOpen={handleOpen}
								openId={report.id}
								color={open && openId === report.id ? 'warning' : 'info'}
							/>
						</Box>
					</>
				</TableCellView>
			</TableRow>

			{/* ________________ COLLAPSE ROW __________________________ */}

			<DataCollapse
				report={report}
				onOpen={handleOpen}
				open={open}
				openId={openId}
				onEdit={onEdit}
				onDeleteConfirm={onDeleteConfirm}
			/>

			{/* Pausal KM */}

			<TableRow>
				<TableCellView align="left" mW={col1} w={150}>
					<>
						<Typography sx={{ fontWeight: 'bold' }} component="span" variant="body2">
							Cena
						</Typography>
					</>
				</TableCellView>

				<TableCellView align="left" mW={200} w="auto">
					<>
						<Typography sx={{ fontWeight: 'bold' }} component="span" variant="body2">
							{`${(priceNormalHours * 1).toLocaleString()} = `}
						</Typography>
						<Typography component="span" variant="body2">
							{`${normalHours} x ${sale}`}
						</Typography>
					</>
				</TableCellView>
			</TableRow>

			{/* nad limit KM */}

			{overLimitHours > 0 && (
				<TableRow>
					<TableCellView align="left" mW={col1} w={150}>
						<>
							<Typography sx={{ fontWeight: 'bold' }} component="span" variant="body2">
								Cena
							</Typography>
							<Typography sx={{ marginLeft: 1 }} component="span" variant="caption">
								nad limit
							</Typography>
						</>
					</TableCellView>

					<TableCellView align="left" mW={200} w="auto">
						<>
							<Typography sx={{ fontWeight: 'bold' }} component="span" variant="body2">
								{`${(priceOverHours * 1).toLocaleString()} = `}
							</Typography>
							<Typography component="span" variant="body2">
								{`${overLimitHours} x ${(saleOver * 1).toLocaleString()} `}
							</Typography>
						</>
					</TableCellView>
				</TableRow>
			)}

			{/* Vícenáklady řidič */}

			<TableRow>
				<TableCellView align="left" mW={col1} w={150}>
					<Typography sx={{ fontWeight: 'bold' }} component="span" variant="body2">
						Vícenáklady řidič
					</Typography>
				</TableCellView>

				<TableCellView align="left" mW={200} w="auto">
					<Typography sx={{ fontWeight: 'bold' }} component="span" variant="body2">
						{costs.toLocaleString()}
					</Typography>
				</TableCellView>
			</TableRow>

			{/* CELKEM HODINY */}

			<TableRow>
				<TableCellView align="left" mW={col1} w={150}>
					<Typography sx={{ fontWeight: 'bold' }} component="span" variant="body2">
						CENA CELKEM
					</Typography>
				</TableCellView>

				<TableCellView align="left" mW={200} w="auto">
					<Typography sx={{ fontWeight: 'bold' }} component="span" variant="body2">
						{totalPriceHoursDay.toLocaleString()}
					</Typography>
				</TableCellView>
			</TableRow>
		</>
	);
};

export default DataTableRows;
